var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drly_article"},[(_vm.data)?_c('div',{staticClass:"body"},[(_vm.src)?_c('div',[_c('el-image',{staticStyle:{"width":"100%"},attrs:{"src":_vm.src,"fit":"cover"}})],1):_vm._e(),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.data.contentLink)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }